import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://apex-med-tech-backend.vercel.app/api';
const StockAuthContext = createContext();

export function StockAuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [token,   setToken]   = useState(() => localStorage.getItem('stockToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/auth/me`, { headers:{ Authorization:`Bearer ${token}` } })
        .then(r => setUser(r.data.user))
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const register = async (data) => {
    const res = await axios.post(`${API}/auth/register`, data);
    localStorage.setItem('stockToken', res.data.token);
    setToken(res.data.token); setUser(res.data.user);
    return res.data;
  };

  const login = async (username, password) => {
    const res = await axios.post(`${API}/auth/login`, { username, password });
    localStorage.setItem('stockToken', res.data.token);
    setToken(res.data.token); setUser(res.data.user);
    return res.data;
  };

  const logout = () => { localStorage.removeItem('stockToken'); setToken(null); setUser(null); };

  return (
    <StockAuthContext.Provider value={{ user, token, loading, register, login, logout, isAuthenticated:!!user }}>
      {children}
    </StockAuthContext.Provider>
  );
}
export const useStockAuth = () => useContext(StockAuthContext);

